import { useRef, useState } from 'react'
import { deleteRecipe } from '../../lib/savenmake'
import Icon from '../Icon'

export default function DeleteRecipeButton({ id, title, disabled, onDeleted }: {
  id: string
  title: string
  disabled?: boolean
  onDeleted: () => void
}) {
  const pending = useRef(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function remove() {
    if (disabled || pending.current) return
    if (!window.confirm(`Delete "${title}"? Its cooking history goes too.`)) return
    pending.current = true
    setBusy(true)
    setError(null)
    try {
      await deleteRecipe(id)
      onDeleted()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'The recipe could not be deleted.')
    } finally {
      pending.current = false
      setBusy(false)
    }
  }

  return <div>
    <button type="button" className="ghost" disabled={disabled || busy} onClick={() => void remove()}>
      <Icon name="trash" size={16} /> {busy ? 'Deleting…' : 'Delete recipe'}
    </button>
    {error && <p className="error" role="alert">{error}</p>}
  </div>
}
